import { render } from "./ServiceOffered.vue?vue&type=template&id=1b22f885&scoped=true"
import script from "./ServiceOffered.vue?vue&type=script&lang=js"
export * from "./ServiceOffered.vue?vue&type=script&lang=js"

import "./ServiceOffered.vue?vue&type=style&index=0&id=1b22f885&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b22f885"]])

export default __exports__